import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export type WhatsAppBlacklist = { phones: string[] };

export function useWhatsAppBlacklist() {
  return useQuery({
    queryKey: ["whatsapp-blacklist"],
    queryFn: () => api.get<WhatsAppBlacklist>("/crm/whatsapp/blacklist"),
  });
}

export function useSaveBlacklist() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (phones: string[]) =>
      api.put<WhatsAppBlacklist>("/crm/whatsapp/blacklist", { phones }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["whatsapp-blacklist"] });
      toast.success("Lista guardada");
    },
  });
}

export function useBlockContact() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (identifier: string) =>
      api.post<WhatsAppBlacklist>("/crm/whatsapp/blacklist/add", { identifier }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["whatsapp-blacklist"] });
      toast.success("Contacto bloqueado");
    },
    onError: () => {
      toast.error("No se pudo bloquear el contacto");
    },
  });
}
